import React, { useCallback, useMemo } from 'react';
import { Checkbox } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { TimeSignal } from 'graphql/types';
import { useFeatureFlag } from 'modules/common/hooks';
import { useMessage } from 'modules/intl';

type NoteListItemCheckboxProps = {
  note: TimeSignal;
  className?: string;
};
const stopPropogationClick = (event: any) => event.stopPropagation();

export const NoteListItemCheckbox: React.FC<NoteListItemCheckboxProps> = ({
  note,
  className
}: NoteListItemCheckboxProps) => {
  const { control, setValue } = useFormContext();
  const name = `${note.date}_${note.id}`;
  const onChange = useCallback(
    (e) => setValue(name, e.target.checked, { shouldDirty: true }),
    [name, setValue]
  );

  const value = useWatch({
    name,
    control
  });
  const isTiwScreenReaderEnabled = useFeatureFlag('isTiwScreenReaderEnabled');
  const selectMsg = useMessage('noteSelector.selectNote');
  const inputProp = useMemo(
    () => ({
      'aria-label': isTiwScreenReaderEnabled ? selectMsg : ''
    }),
    [isTiwScreenReaderEnabled, selectMsg]
  );

  return (
    <Checkbox
      color={'default'}
      className={className}
      onChange={onChange}
      onClick={stopPropogationClick}
      checked={Boolean(value)}
      data-testid="note-list-item-checkbox"
      inputProps={inputProp}
    />
  );
};
